export default {
  anchorEditor: true,
  anchorPreview: true,
  attributeInserter: false,
  allowMediaInserter: false,
  textFormatter: true,
  allowFilePaste: false,
  allowUploads: false,
  allowMention: false,
  allowAlignment: false,
  allowAttachments: false,
  allowAttribute: false,
  allowBold: true,
  allowItalic: true,
  allowAnchor: true,
  allowHeading: false,
  allowMarkdownHeadings: false,
  allowMarker: false,
  allowSubheading: false,
  allowOrderedList: true,
  allowUnorderedList: true,
  allowImage: false,
  allowButton: false,
  allowVideo: false,
  allowSocial: false,
  allowCode: false,
  allowHtml: false,
  allowEmoji: true,
  readOnly: false,
  displaySocialBlocksAsButtons: false,
  urlReplacement: true,
  // Perform automatic conversion of URLs to anchors
  markdownLinks: true,
  // Convert markdown links to anchors
  markdownInlineCode: false,
  autoFocusTopLeft: false,
  recoverErrors: true,
  allowRtl: false,
  stripEmptyTrailingBlocks: true
};